import { boot } from '@dazn/bootstrap-lib';

const DEV_MODE_STORAGE_KEY = 'isDevModeEnabled';
export const createDevModeReader = (
    asyncStorage: boot.storage.AsyncStorage,
) => {
    let hasReadDevMode = false;
    let isDevModeEnabled = false;
    // FIXME: hack because startup, user module and optimizely (safe mode flag)
    // needs this flag and it initialises before the API
    return {
        isEnabled: () => {
            if (!hasReadDevMode) {
                throw new Error(
                    '[Bootstrap] Bad init: devMode is not known yet!',
                );
            }
            return isDevModeEnabled;
        },
        readFromStorage: () =>
            asyncStorage.getItem(DEV_MODE_STORAGE_KEY).then(dmVal => {
                hasReadDevMode = true;
                isDevModeEnabled = dmVal === 'true';
            }),
        update: (isEnabled: boolean) => {
            isDevModeEnabled = isEnabled;
            return asyncStorage.setItem(
                DEV_MODE_STORAGE_KEY,
                String(isEnabled),
            );
        },
    };
};
